import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/VacancyModule/VacancyModule.tsx");
